import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { AppInsights } from 'applicationinsights-js';

@Injectable()
export class ApplicationInsightsService {
    private config: Microsoft.ApplicationInsights.IConfig = {
        instrumentationKey: environment.appInsights.instrumentationKey
    };
    constructor() {
        if (!AppInsights.config) {
            AppInsights.downloadAndSetup(this.config);
        }
    }

    logPageView(name?: string, url?: string, properties?: any,
        measurements?: any, duration?: number) {
            AppInsights.trackPageView(name, url, properties, measurements, duration);
        }

    logEvent(name: string, properties?: any, measurements?: any) {
        AppInsights.trackEvent(name, properties, measurements);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/_services/applicationInsights.service.ts